<!--
Author: TangChen
Date: 2019-01-03
Desc: 购买定投基金，由index.js 配置引入
-->
<template>
    <div class="comp-plan-buy comp">
        <div v-if="showTabs" class="flex fs18 lin18 mt12">
            <div
                :class="[selectedTab === '1' ? 'active-tab' : '']"
                class="pointer bor_E4E4E4 bor_b_0 br-t-12 c_333 pt14 pb14 pl44 pr44"
                v-on:click="clickTab('1')"
            >
                普通定投
            </div>
            <div
                v-if="canShowTargetProfitTab"
                :class="[selectedTab === '7' ? 'active-tab' : '']"
                class="pointer bor_E4E4E4 bor_b_0 br-t-12 c_333 pt14 pb14 pl44 pr44"
                v-on:click="clickTab('7')"
            >
                目标盈定投
            </div>
            <div
                v-if="canShowSmartInvestTab"
                :class="[selectedTab === '4' ? 'active-tab' : '']"
                class="pointer bor_E4E4E4 bor_b_0 br-t-12 c_333 pt14 pb14 pl44 pr44"
                v-on:click="clickTab('4')"
            >
                智能定投
            </div>
        </div>
        <div class="bor_E4E4E4">
            <el-form
                v-show="!buySuccess"
                ref="fundInfo"
                :model="fundInfo"
                :rules="rules"
                label-width="350px"
                class="pwdForm"
                inline-message
                v-on:submit.native.prevent
            >
                <el-form-item
                    v-if="$route.query.isCom && fund.subfundinfos && fund.subfundinfos.length"
                    label="基金组合及比例："
                >
                    <div
                        v-for="(item, index) in fund.subfundinfos"
                        :key="index"
                        class="flex between w390 hcenter"
                    >
                        <div class="pr8 nowrap">[{{ item.fundcode }}]{{ item.fundname }}</div>
                        <div class="bor_F1F1F1_dashed w100x"></div>
                        <div class="pl8">
                            <!-- item.ratio * 100 + % 的时候0.07会丢失精度展示7.00000000001%-->
                            {{ Math.round(item.ratio * 100 * 1000) / 1000 + "%" }}
                        </div>
                    </div>
                </el-form-item>
                <el-form-item v-else label="基金名称：" class="form-text">
                    <div v-cloak class="text-con">
                        {{ fund.fundname + "(" + fund.fundcode + ")" }}
                    </div>
                </el-form-item>
                <el-form-item
                    v-if="!$route.query.isCom"
                    label="定投计划名称："
                    prop="buyplanname"
                    class="form-text"
                >
                    <el-input
                        v-model.trim="fundInfo.buyplanname"
                        placeholder="请输入投资计划名称"
                        :maxlength="32"
                        :disabled="action === '2'"
                    />
                </el-form-item>
                <el-form-item
                    v-if="!$route.query.isCom"
                    label="资金来源："
                    prop="way"
                    class="form-text"
                >
                    <el-radio-group v-model="fundInfo.way" :disabled="action !== '0'">
                        <el-radio label="2" name="sell">银行卡</el-radio>
                        <el-radio
                            v-if="showXjbOption"
                            label="1"
                            name="sell"
                            :disabled="
                                $util.fmtNum(xjbAll) === '--' ||
                                fund.fundcode === xjbFundInfo.fundcode
                            "
                        >
                            {{ $const.getXJBParam("name") }}
                            <span>
                                (可用余额：
                                <span style="color: var(--color-primary)">
                                    {{ $util.fmtNum(xjbAll) }}
                                </span>
                                元)
                            </span>
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item
                    v-if="fundInfo.way == '2' && hasBankRroute"
                    label="扣款账号："
                    prop="selectedBankid_card"
                    class="payway-list"
                >
                    <div class="flex">
                        <div>
                            <el-select
                                v-model="selectedBankid_card"
                                placeholder="请选择支付方式"
                                :class="{
                                    hasVal: bankInfo && bankInfo.label && fundInfo.pay != ''
                                }"
                                :disabled="action !== '0'"
                            >
                                <el-option-group class="bank-sel">
                                    <el-option
                                        v-for="item in bankListsOfR"
                                        :key="item.bankid_card"
                                        :label="item.label"
                                        :value="item.bankid_card"
                                        class="el-option-group_wrap"
                                    >
                                        <div v-if="!item.bankAdd" class="bank-info">
                                            <img
                                                :src="$util.getImg(item.bankid_card.split('_')[0])"
                                                alt=""
                                            />
                                            <span>{{ $util.getDimCard(item.label) }}</span>
                                            <p v-if="!item.bankAdd">
                                                {{ item.text }}
                                            </p>
                                        </div>
                                        <div v-if="item.bankAdd" class="option-group clear">
                                            {{ item.bankCate }}
                                            <el-button
                                                type="primary"
                                                v-on:click.prevent="goAddBankOrBank"
                                            >
                                                {{ item.bankAdd }}
                                            </el-button>
                                        </div>
                                    </el-option>
                                </el-option-group>
                            </el-select>
                            <div v-if="bankInfo && bankInfo.label" class="el-select-img">
                                <img :src="$util.getImg(bankInfo.bankcode)" alt="" />
                                <span class="k-text-flow long-text-show">
                                    {{
                                        $util.getDimCard(
                                            bankInfo.label.split("-").length === 1
                                                ? bankInfo.label
                                                : bankInfo.label.split("-")[1]
                                        )
                                    }}
                                </span>
                            </div>
                        </div>
                        <div
                            v-if="fundInfo.way == '2'"
                            class="text-primary fs14 ml10"
                            v-on:click="goAddBankPlan"
                        >
                            新增银行卡
                        </div>
                    </div>
                </el-form-item>
                <el-form-item v-else label="扣款账号：" prop="pay" class="payway-list">
                    <div class="flex">
                        <div :class="{ w400: fundInfo.way === '2' }">
                            <el-select
                                v-if="fundInfo.way !== '1' && bankLists.length > 0"
                                v-show="action === '0'"
                                v-model="fundInfo.pay"
                                placeholder="请选择支付方式"
                                :class="{
                                    hasVal: bankInfo && bankInfo.label,
                                    w400: fundInfo.way === '2'
                                }"
                                :disabled="action !== '0'"
                                v-on:change="bankSel"
                            >
                                <el-option-group
                                    v-for="(group, index) in bankLists"
                                    :key="index"
                                    :label="group.label"
                                    class="bank-sel"
                                >
                                    <el-option
                                        v-for="item in group.options"
                                        :key="item.bankcardid"
                                        :label="item.label"
                                        :value="item.bankcardid"
                                    >
                                        <div v-if="!item.bankAdd" class="bank-info flex between">
                                            <div>
                                                <img :src="$util.getImg(item.bankcode)" alt="" />
                                                <span>{{ item.label }}</span>
                                                <p v-if="!item.bankAdd">
                                                    {{ item.text }}
                                                </p>
                                                <div v-if="!$util.isEmpty(item.discountrate)">
                                                    {{ Number(item.discountrate) * 10 }}折
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="item.bankAdd" class="option-group clear">
                                            {{ item.bankCate }}
                                            <el-button
                                                type="primary"
                                                v-on:click.prevent="goAddBank"
                                            >
                                                {{ item.bankAdd }}
                                            </el-button>
                                        </div>
                                    </el-option>
                                </el-option-group>
                            </el-select>
                            <div
                                v-if="fundInfo.way !== '1' && bankInfo && bankInfo.label"
                                class="el-select-img flex between pr25"
                            >
                                <div>
                                    <img :src="$util.getImg(bankInfo.bankcode)" alt="" />
                                    <span class="k-text-flow long-text-show">
                                        {{ bankInfo.label }}
                                    </span>
                                </div>
                                <div v-if="!$util.isEmpty(bankInfo.discountrate)">
                                    {{ Number(bankInfo.discountrate) * 10 }}折
                                </div>
                            </div>
                            <el-radio-group
                                v-if="
                                    (fundInfo.way === '1' && xjbInfo.length === 0) ||
                                    (fundInfo.way === '2' && bankLists.length === 0)
                                "
                                class="bank-radio"
                            >
                                <el-radio label="no-selec" border>
                                    <div class="bank-img-sel">
                                        <div v-if="fundInfo.way === '1'" class="k-text-flow">
                                            您的{{ $const.getXJBParam("sname") }}还未充值，请立即
                                            <span
                                                class="like-a"
                                                v-on:click="
                                                    $router.push({ name: 'currencycharge' })
                                                "
                                            >
                                                前往充值
                                            </span>
                                        </div>
                                        <div v-else class="k-text-flow">
                                            您还未添加银行卡，请立即
                                            <span class="like-a" v-on:click="goAddBankPlan">
                                                前往添加
                                            </span>
                                        </div>
                                    </div>
                                </el-radio>
                            </el-radio-group>
                            <el-radio-group
                                v-if="fundInfo.way === '1' && xjbInfo.length > 0"
                                v-model="fundInfo.pay"
                                class="bank-radio"
                            >
                                <el-radio
                                    v-for="bank in xjbInfo"
                                    :key="bank.transactionaccountid"
                                    :label="bank.transactionaccountid"
                                    border
                                >
                                    <div class="bank-img-sel">
                                        <img :src="$util.getImg(bank.bankcode)" alt="" />
                                        <div class="k-text-flow long-text-show">
                                            <span
                                                class="bank-name"
                                                :title="$cache.getDict('110080', bank.bankcode)"
                                            >
                                                {{ bank.channelDisplayName }}
                                            </span>
                                            总额(元):
                                            <span class="bank-balance">
                                                {{ $util.fmtNum(bank.xjbasset) }}
                                            </span>
                                        </div>
                                        <i class="el-icon-check" aria-hidden="true" />
                                    </div>
                                </el-radio>
                            </el-radio-group>
                        </div>
                        <div
                            v-if="fundInfo.way == '2'"
                            class="text-primary fs14 ml10"
                            v-on:click="goAddBankPlan"
                        >
                            新增银行卡
                        </div>
                    </div>
                </el-form-item>
                <el-form-item
                    v-if="!$route.query.isCom"
                    label="收费方式："
                    prop="sharetype"
                    class="form-text"
                >
                    <el-select v-model="fundInfo.sharetype" :disabled="fund.sharetype !== '2'">
                        <el-option value="0" label="前收费"></el-option>
                        <el-option value="1" label="后收费"></el-option>
                    </el-select>
                    <el-tooltip placement="top">
                        <div slot="content">
                            前收费是在申购基金时收取申购费,
                            <br />
                            而后收费则是在申购时不收费，
                            <br />
                            在赎回时才收取手续费用。
                        </div>
                        <img src="../../assets/img/tip.png" class="w18 h18 ml12" />
                    </el-tooltip>
                </el-form-item>
                <el-form-item label="定投周期：" prop="debitcycle" class="form-text">
                    <el-radio-group v-model="fundInfo.debitcycle" :disabled="action === '2'">
                        <el-radio
                            v-for="(item, index) in debitcycleArr"
                            v-show="!($route.query.isCom && item.subitem === '3')"
                            :key="index"
                            :label="item.subitem"
                            name="debitcycle"
                        >
                            {{ item.subitemname }}
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <div v-if="fundInfo.debitcycle !== '3'">
                    <el-form-item
                        label="定投日期："
                        prop="debitdate"
                        :class="{
                            'form-text': fund.sign && !isPwdCheck && !(wisdom && action !== '0')
                        }"
                    >
                        <el-select
                            v-model="fundInfo.debitdate"
                            placeholder="请选择扣款日期"
                            :disabled="action === '2'"
                            v-on:change="queyNextplandate"
                        >
                            <el-option
                                v-for="(item, index) in debitdateArr"
                                :key="index"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                        <p
                            v-if="selectedTab === '1' && fundInfo.debitcycle && fundInfo.debitdate"
                            class="tips-text"
                        >
                            下次扣款日期
                            {{ formatDate(nextplandate) }}
                        </p>
                    </el-form-item>
                </div>
                <div v-if="selectedTab === '4'" class="bor_D9D9D9 ml240 mr240 mb24">
                    <el-tabs v-model="activeName">
                        <el-tab-pane label="标准智能定投" name="first"></el-tab-pane>
                        <el-tab-pane label="个性智能定投" name="second"></el-tab-pane>
                    </el-tabs>
                    <div class="tabForm">
                        <el-form-item label="指数类型：">
                            <el-select
                                v-model="fundInfo.indextype"
                                :disabled="action == '2' || activeName === 'first'"
                                v-on:change="handleIndexTypeChange"
                            >
                                <el-option
                                    v-for="(item, index) in indexTypeOptions"
                                    :key="index"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>

                            <el-tooltip placement="top">
                                <div slot="content">
                                    参考指数则应选择与所投资基金相
                                    <br />
                                    关性较高的参数，可考虑基金业绩
                                    <br />
                                    比较基准中涉及的股票指数。
                                </div>
                                <img src="../../assets/img/tip.png" class="w18 h18 ml12" />
                            </el-tooltip>
                        </el-form-item>
                        <el-form-item label="均线类型：">
                            <el-select
                                v-model="fundInfo.policyvalue"
                                :disabled="action == '2' || activeName === 'first'"
                            >
                                <el-option
                                    v-for="(item, index) in averageTypeOptions"
                                    :key="index"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>

                            <el-tooltip placement="top">
                                <div slot="content">
                                    所取均线越大、收益越大、两者正相关。
                                    <br />
                                    在投资者实际操作中，运用周期较长的
                                    <br />
                                    均线（如750日以上均线，即3年以上均
                                    <br />
                                    线）的可行性较差，虽然运用他们可以
                                    <br />
                                    获得较高收益，但是总的定投金额少，
                                    <br />
                                    即意味着'智能定投'发生的概率小或者每
                                    <br />
                                    次'智能定投'的金额远远少于'普通定投'
                                    <br />
                                    ，对于投资者来讲，可投资的机会较小，
                                    <br />
                                    实际意义不大。所以我们建议用中均线，
                                    <br />
                                    即180、250或500日均线做为投资参考。
                                </div>
                                <img src="../../assets/img/tip.png" class="w18 h18 ml12" />
                            </el-tooltip>
                        </el-form-item>
                        <el-form-item label="金额控制参数级差：">
                            <el-select
                                v-model="fundInfo.investscale"
                                :disabled="action == '2' || activeName === 'first'"
                            >
                                <el-option label="10%" value="0.1"></el-option>
                                <el-option label="20%" value="0.2"></el-option>
                                <el-option label="30%" value="0.3"></el-option>
                            </el-select>
                            <el-tooltip placement="top">
                                <div slot="content">
                                    根据实证分析，我们认为选取级差为基础金额
                                    <br />
                                    的10%-30%最有效，所得到的效果也最优。
                                </div>
                                <img src="../../assets/img/tip.png" class="w18 h18 ml12" />
                            </el-tooltip>
                        </el-form-item>
                        <el-form-item label="基础金额：" prop="amount">
                            <amount-input
                                v-model="fundInfo.amount"
                                :placeholder="pla"
                                :disabled="action === '2'"
                            />
                        </el-form-item>
                        <el-form-item v-if="Number(fundInfo.amount)" label="金额确认：">
                            {{ $util.capitalRMB(fundInfo.amount) }}
                        </el-form-item>
                    </div>
                </div>
                <el-form-item v-if="selectedTab !== '4'" label="每期扣款金额：" prop="amount">
                    <amount-input
                        v-model="fundInfo.amount"
                        :placeholder="pla"
                        :disabled="action === '2'"
                    />
                </el-form-item>
                <el-form-item
                    v-if="selectedTab !== '4' && Number(fundInfo.amount)"
                    label="确认金额："
                >
                    {{ $util.capitalRMB(fundInfo.amount) }}
                </el-form-item>
                <el-form-item
                    v-show="feeGate.benchmarkrate || feeGate.benchmarkrate == 0"
                    label="定投费率："
                    class="form-text"
                >
                    <span v-if="feeGate.benchmarkrate == feeGate.executionrate">
                        {{ $util.fmtToPercent(feeGate.benchmarkrate, 2) }}
                    </span>
                    <span
                        v-if="feeGate.benchmarkrate != feeGate.executionrate"
                        style="color: var(--color-text-accent); text-decoration: line-through"
                    >
                        {{ $util.fmtToPercent(feeGate.benchmarkrate, 2) }}
                    </span>
                    <span
                        v-if="feeGate.benchmarkrate != feeGate.executionrate"
                        style="color: var(--color-primary); margin-left: 4px"
                    >
                        {{ $util.fmtToPercent(feeGate.executionrate, 2) }}
                    </span>
                </el-form-item>
                <el-form-item
                    v-show="feeGate.estimatedcost || feeGate.estimatedcost == 0"
                    label="预估手续费："
                    class="form-text"
                >
                    <span style="color: var(--color-primary)">
                        {{
                            fundInfo.way === "2" && isagreeeasybuy === "1"
                                ? "0.00"
                                : $util.fmtNum(feeGate.estimatedcost)
                        }}元
                    </span>
                    <span v-if="feeGate.costsavings > 0" style="color: var(--color-text-accent)">
                        省{{
                            fundInfo.way === "2" && isagreeeasybuy === "1"
                                ? "0.00"
                                : $util.fmtNum(feeGate.costsavings)
                        }}元
                    </span>
                    <span
                        style="margin-left: 5px; color: var(--color-text-accent); font-size: 12px"
                    >
                        (仅为预计金额，以基金公司确认为准)
                    </span>
                </el-form-item>
                <el-form-item
                    v-if="selectedTab == '7'"
                    prop="selectedTargetrate"
                    label="目标收益："
                >
                    <div class="flex hcenter fs16 lin16">
                        <el-radio-group v-model="selectedTargetrate">
                            <el-radio label="0.05">5%</el-radio>
                            <el-radio label="0.08">8%</el-radio>
                            <el-radio label="0.10">10%</el-radio>
                            <el-radio label="">自选</el-radio>
                        </el-radio-group>
                        <div
                            v-show="selectedTargetrate === ''"
                            class="flex hcenter bor_D9D9D9 pt12 pb12 pl18 pr13 ml8"
                        >
                            <input
                                id="par3Id"
                                v-model="inputTargetrate"
                                type="text"
                                class="w36 bor_none c_999 outline_none"
                            />
                            <span>%</span>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item
                    v-if="selectedTab == '7'"
                    label="止盈后自动赎回到："
                    prop="sellTo"
                    class="payway-list"
                >
                    <div class="flex lin20">
                        <div
                            class="bor_D9D9D9 br_8 pl10 pr15 pt16 pb44 mr20 relative pointer"
                            v-on:click="profitredeemflag = '0'"
                        >
                            <div class="fs18 c_333 mb10">{{ $const.getXJBParam("name") }}</div>
                            <div class="c_999 fs14">
                                最新七日年化收益率:{{
                                    formatCurrencyAnnualRate(xjbFundInfo.growthrate)
                                }}。
                            </div>
                            <div class="c_999 fs14">买基金立享优惠</div>
                            <img
                                src="../../assets/img/recommend.png"
                                class="absolute w65 h65 _t2 _r2"
                            />
                            <div
                                v-if="profitredeemflag === '0'"
                                class="checked-bg-primary h30 w100x br-b-7 absolute l0 b0 flex wcenter hcenter"
                            >
                                <img
                                    src="../../assets/img/square-checked-white.png"
                                    class="w16 h12"
                                />
                            </div>
                        </div>
                        <!-- <div
                            class="bor_D9D9D9 br_8 pl10 pr15 pt16 pb44 relative pointer"
                            v-on:click="profitredeemflag = '1'"
                        >
                            <div class="fs18 c_333 mb10">银行卡</div>
                            <div class="c_999 fs14">银行活期存款利率：0.35%。</div>
                            <div class="c_999 fs14">若不急需现金，建议转至钱柜</div>
                            <div
                                v-if="profitredeemflag === '1'"
                                class="bc_E60012 h30 w100x br-b-7 absolute l0 b0 flex wcenter hcenter"
                            >
                                <img
                                    src="../../assets/img/square-checked-white.png"
                                    class="w16 h12"
                                />
                            </div>
                        </div> -->
                    </div>
                </el-form-item>
                <el-form-item
                    v-show="fundInfo.debitcycle == '0' && fundInfo.debitdate >= 29"
                    label="当月日期不足处理："
                    prop="nonexistdayflag"
                    class="form-text"
                >
                    <el-radio-group v-model="fundInfo.nonexistdayflag" :disabled="action === '2'">
                        <el-radio
                            v-for="item in nonexistdayArr"
                            :key="item.subitem"
                            :label="item.subitem"
                            name="nonexistdayflag"
                        >
                            {{ item.subitemname }}
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item
                    v-if="
                        $util.getConfig().showSpecial &&
                        fund.fundcode !== xjbFundInfo.fundcode &&
                        selectedTab !== '7' &&
                        fundInfo.way === '2' &&
                        !$route.query.isCom &&
                        $util.xjbIsOpen() &&
                        !mrfflag &&
                        fundData.internalfundtype != '6'
                    "
                >
                    <div class="flex hcenter">
                        <img
                            v-if="isagreeeasybuy === '1'"
                            src="../../assets/img/circle-checked.png"
                            class="w20 h20 pointer"
                            v-on:click="isagreeeasybuy = '0'"
                        />
                        <img
                            v-if="isagreeeasybuy === '0'"
                            src="../../assets/img/circle-unchecked.png"
                            class="w20 h20 pointer"
                            v-on:click="isagreeeasybuy = '1'"
                        />
                        <div class="ml10">
                            省钱购（自动帮您用{{ $const.getXJBParam("sname") }}买基金，享0折优惠）
                        </div>
                        <el-tooltip placement="top">
                            <div slot="content">
                                省钱购是什么？
                                <br />
                                银行卡资金将先充值{{
                                    $const.getXJBParam("name")
                                }}，后自动帮您买入目标基金
                                <br />
                                省钱购有什么好处？
                                <br />
                                购买基金费用可低至0折
                                <br />
                                什么产品支持省钱购？
                                <br />
                                除货币基金外和产品C类份额外，都支持使用省钱购买基金
                            </div>
                            <img src="../../assets/img/tip.png" class="w18 h18 ml12" />
                        </el-tooltip>
                    </div>
                </el-form-item>
                <el-form-item
                    v-if="isPwdCheck"
                    label="交易密码："
                    prop="pwd"
                    :class="{ 'form-text': fund.sign }"
                >
                    <el-input
                        v-model.trim="fundInfo.pwd"
                        type="password"
                        placeholder="请输入交易密码"
                        :maxlength="16"
                    />
                    <span
                        class="redemp-btn"
                        v-on:click.prevent="$router.push({ name: 'tradepwd' })"
                    >
                        <span class="like-a">忘记密码？</span>
                    </span>
                </el-form-item>
                <el-form-item style="margin-left: -80px">
                    <div v-if="readFileInfoList.length !== 0" class="protocol-checkbox-group">
                        <div class="protocol-checkbox-label">
                            <input v-model="checkbox" type="checkbox" />
                            <span>我已阅读并同意:</span>
                        </div>
                        <ul>
                            <li
                                v-for="(item, index) in readFileInfoList"
                                :key="index"
                                class="flex hcenter"
                            >
                                <!--<a v-if="item.textaddress.startsWith('http')" v-on:click="getClick(index)"-->
                                <!--:href="item.textaddress" style="text-decoration:none; color: red"-->
                                <!--target="_blank">《{{item.textname}}》</a>-->
                                <!--<span v-else   v-on:click="showPdf(item.textaddress)">《{{item.textname}}》</span>-->
                                <!-- v-if="$cache.getCompanyInfoParam().pdf_open_way === '0'" -->
                                <!-- :href="$util.src('/sale-mid-ump/file/cmsDownload', { fileCode: item.fileid,isopenfile:1 }, true)" -->
                                <a target="_blank" v-on:click="getClick(index)">
                                    《{{ item.filename }}》
                                </a>
                                <!-- <a v-else :href="item.textaddress" style="text-decoration:none; color: red" target="_blank">《{{item.filename}}》</a> -->
                            </li>
                        </ul>
                    </div>
                </el-form-item>
                <el-form-item v-if="fundInfo.way == '1' && tradeRestrictionsShow">
                    <div>
                        <span class="text-primary">
                            温馨提示：{{ $cache.getCompanyInfoParam("10102035") }}
                        </span>
                    </div>
                </el-form-item>
                <el-form-item>
                    <div style="width: 50%">
                        <el-button class="medium bc_E4E4E4 c_666666" v-on:click="$router.back()">
                            返回重选
                        </el-button>
                        <el-button
                            type="primary"
                            class="medium"
                            :disabled="
                                hasProductOverview || time > 0 || checkBuy == false || isOpen
                            "
                            v-on:click="doAction"
                        >
                            确定
                        </el-button>
                    </div>
                </el-form-item>
            </el-form>
            <pdf-popup
                base64
                :visible="pdfVisible"
                :need-time="needTime"
                :read-file-info-list="currentFileInfoList"
                :show-close="true"
                v-on:close="finishReading"
                v-on:cancel="cancelReading"
            ></pdf-popup>
            <fund-protocol
                v-if="!buySuccess"
                v-model="protocol"
                :fund="fund"
                :show-proto-arr="false"
                v-on:all-read="generalBuy"
            />
            <result
                v-if="buySuccess"
                :active="2"
                :result="result"
                v-on:return-page="reset"
                v-on:return-login="$router.push({ name: 'myplan' })"
            />
        </div>
        <footerQuestions
            v-if="$const.warmReminderDisplay"
            :common-question="commonQuestion"
            :warning-html="warningHtml"
        ></footerQuestions>
        <el-dialog
            title="温馨提示"
            :visible.sync="tipVisible"
            :close-on-click-modal="false"
            width="50%"
        >
            <div class="bold mb20">
                您当前自定义的目标收益率较低，可能会因为以下原因导致亏损等。
            </div>
            <div class="mb20">(1)部分基金7日内赎回将会收取1.5%赎回费，详情请参阅基金公告</div>
            <div>
                (2)当T日收益率达到预设的目标收益时（QDII基金为T-1日），在T+1日将自动赎回至{{
                    profitredeemflag == 0 ? $const.getXJBParam("name") : "银行卡"
                }}，T+1日净值波动与赎回费可能会影响实际的收益。赎回后定投继续进行。
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button v-on:click="tipVisible = false">重新选择</el-button>
                <el-button
                    :loading="isOpen"
                    type="primary"
                    v-on:click="
                        tipVisible = false;
                        getSdxProtocol();
                    "
                >
                    已了解
                </el-button>
            </div>
        </el-dialog>
        <buy-risk-dialog
            :visible.sync="buyRiskdialogVisible"
            :type="dialogType"
            :content="dialogContent"
            :button-text="dialogButtonText"
            v-on:confirm="handleDialogConfirm"
        />
        <fund-sdx-dialog
            :fund="sdxFundInfo"
            :sdx-dialog-visible="sdxDialogVisible"
            v-on:dialogClosed="sdxDialogClose"
            v-on:dialogContinue="sdxDialogContinue"
        />
    </div>
</template>
<script>
import result from "@/components/layout/result";
import fundProtocol from "@/components/form/fundProtocol";
import fundSdxDialog from "@/components/form/fundSdxDialog";
import cache from "@/assets/js/cache";
import PdfPopup from "@/components/util/pdfPopup";
import fundApi from "@/api/fund";
import footerQuestions from "@/components/layout/footerQuestions.vue";
import warningHtml from "@/constant/warning_html.js";
import commonApi from "@/api/common";
import AmountInput from "@/components/common/AmountInput.vue";
import format from "date-fns/format";
import userApi from "@/api/user";
import buyRiskDialog from "@/components/fund/buyRiskDialog.vue";
import { sceneEnum } from "@/util/util_jfit";

export default {
    name: "PlanBuy",
    components: {
        result,
        fundProtocol,
        fundSdxDialog,
        PdfPopup,
        footerQuestions,
        buyRiskDialog,
        AmountInput
    },
    props: {
        generalFund: {
            // 基金信息基本数据
            required: true,
            type: Object
        },
        setFund: {
            // 智慧定投专属数据
            type: Object,
            default: function () {
                return {};
            }
        },
        wisdom: {
            // 是否是智慧定投
            type: Boolean,
            default: false
        },
        action: {
            // 定投操作类型，0签署定投协议，1修改定投协议，2启用定投协议
            type: String,
            default: "0"
        }
    },
    data() {
        return {
            // 表单信息
            fundInfo: {
                all: "0.00",
                amount: "",
                way: "",
                sharetype: "",
                buyplanname: "",
                debitcycle: "",
                debitdate: "",
                indextype: "",
                policyvalue: "",
                investscale: "0.1",
                pay: "",
                pwd: "",
                nonexistdayflag: ""
                // protocol: ""
            },
            feeGate: {},
            isPwdCheck: false, // 是否校验密码
            pla: "请输入起购金额",
            buySuccess: false, // 购买状态
            result: {
                // 结果页面信息
                cla: "register-success",
                msg: "您定投的申请已提交成功！",
                btnMsg: "预计下次扣款日期11月30日，如遇节假日则顺延，请耐心等待",
                special: false,
                btnL: {
                    text: "继续定投",
                    event: "return-page"
                },
                btnR: {
                    text: "我的定投",
                    event: "return-login"
                }
            },
            xjbAll: 0,
            time: 0, // 发送短信倒计时
            fund: {}, // 基金信息获取
            bankLists: [], // 银行卡列表
            limit: { text: "定投金额范围为：", min: "0", max: "0" }, // 限额
            rules: {
                // 校验规则配置
                amount: [
                    { required: true, message: "请输入每期扣款金额", trigger: "blur" },
                    { validator: this.amountLimit, mes: "投资金额", trigger: "blur" }
                ],
                pay: [{ required: true, message: "请选择支付方式", trigger: "change" }],
                selectedBankid_card: [{ validator: this.validateCard, trigger: "change" }],
                buyplanname: [{ validator: this.checkBuyPlanName, trigger: "blur" }],
                debitcycle: [{ required: true, message: "请选择扣款周期", trigger: "change" }],
                debitdate: [{ validator: this.checkDebitdate, trigger: "change" }],
                indextype: [{ required: true, message: "请选择参考指数", trigger: "change" }],
                policyvalue: [{ required: true, message: "请选择均线", trigger: "change" }],
                investscale: [{ required: true, message: "请选择极差", trigger: "change" }],
                pwd: [{ required: true, message: "请输入交易密码", trigger: "blur" }],
                sharetype: [{ required: true, message: "请选择收费方式", trigger: "change" }],
                selectedTargetrate: [
                    { validator: this.checkDebitcycle, trigger: ["change", "blur"] }
                ]
            },
            bankInfo: {}, // 校验银行卡信息
            xjbInfo: [],
            cfmdate: "", // 确认日期
            debitcycleArr: [],
            protocol: false,
            debitdateArr: [],
            subjectIndex: [],
            investMove: [],
            xjbSel: {}, // 当前选中现金宝信息
            firstinvestdate: "",
            bankId: "", // 已选中网点信息
            checkbox: false, // 阅读确认1
            checkTime: true, // 阅读确认2
            checkBuy: true,
            readFileInfoList: [], // 披露文件信息
            readappno: "", // 申请单编号
            countdown: "",
            interval: "",
            nonexistdayArr: [
                {
                    subitem: "0",
                    subitemname: "当月最后一日"
                },
                {
                    subitem: "1",
                    subitemname: "顺延到下月1号"
                }
            ],
            currentFileInfoList: [], // 当前阅读信批文件
            pdfVisible: false,
            needTime: false,
            hasBankRroute: false, // 是否开启智能路由
            bankListsOfR: [], // 不区分支付渠道的银行卡信息
            selectedBankid_card: "", // 智能路由下选择的银行卡
            hasAccount: false, // 是否有智能路由推荐渠道下的银行卡
            recChannelid: "", // 推荐的channelid
            recChannelname: "", // 推荐的渠道网点名
            timer: "",
            isOpen: false, // 正在发起定投
            clickBtn: null, // 定时器
            isagreeeasybuy: "0",
            commonQuestion: [],
            warningHtml: "",
            selectedTab: "1",
            profitredeemflag: "0",
            selectedTargetrate: "0.05",
            inputTargetrate: "",
            oldInputTargetrate: "",
            activeName: "first",
            xjbFundInfo: {}, // 现金宝基金信息
            tipVisible: false,
            info: {},
            mrfflag: true, // 是否中港互认
            fundData: {},
            nextplandate: "",
            tradeRestrictionsShow: false, // 节假日xx宝的提示
            buyRiskdialogVisible: false, // 弹窗显示状态
            dialogType: "", // 弹窗类型（forbid/warn）
            dialogContent: "", // 弹窗文案
            dialogButtonText: "", // 按钮文案
            oldercustRiskWarnPassed: false, // 高龄客户风险提示已确认
            oldercustRiskChecking: false, // 高龄客户风险提示校验中
            hasProductOverview: false, // 确定按钮
            hasReadProductOverview: false, // 是否已完整阅读产品概要
            cfgIndexAvgList: [], // 接口原始数据
            indexAvgMap: {}, // indextype -> allowaveragetype[]
            indexTypeOptions: [], // 指数类型下拉
            averageTypeOptions: [], // 均线类型下拉（动态）
            isRealtaXjb: false, // cfgFundrealtimeQueryAll接口有返回值则为实时TA现金宝
            hasXjbConvertRelation: false, // 当前产品与现金宝是否有转换关系
            sdxFundInfo: {},
            sdxDialogVisible: false,
            sdxGatePassed: false,
            pendingSdxAction: null
        };
    },
    computed: {
        tradeInfoParam() {
            return this.$cache.getParamValue("trade_info") || {};
        },
        targetProfitPlanEnabled() {
            return this.tradeInfoParam.enableprofittargetplan !== false;
        },
        indexPlanEnabled() {
            return this.tradeInfoParam.enableindexplan !== false;
        },
        companyPlanFlags() {
            return this.$cache.getCompanyInfoParam("10301003") || "";
        },
        canShowTargetProfitTab() {
            return this.targetProfitPlanEnabled && this.companyPlanFlags.indexOf("A86") > -1;
        },
        canShowSmartInvestTab() {
            return this.indexPlanEnabled && this.companyPlanFlags.indexOf("A19") > -1;
        },
        showTabs() {
            return (
                !this.$route.query.isCom &&
                !this.buySuccess &&
                this.fund.fundcode !== this.xjbFundInfo.fundcode &&
                this.action === "0" &&
                (this.canShowTargetProfitTab || this.canShowSmartInvestTab)
            );
        },
        // 现金宝选项显示条件
        showXjbOption() {
            // 基础条件
            const baseCondition =
                this.selectedTab !== "7" &&
                !this.mrfflag &&
                this.fundData.internalfundtype != "6" &&
                this.$util.xjbIsOpen() &&
                !(this.selectedTab === "4" && !this.isRealtaXjb);
            // 如果不是实时TA现金宝，需要检查转换关系
            if (!this.isRealtaXjb) {
                return baseCondition && this.hasXjbConvertRelation;
            }

            return baseCondition;
        }
    },
    watch: {
        "fundInfo.amount"(val) {
            if (this.hasBankRroute && this.fundInfo.way === "2" && this.action === "0") {
                // 获取智能路由
                this.handleBankRroute();
                return;
            }
            this.isAmount(val);
        },
        "fundInfo.way"(val) {
            this.$refs["fundInfo"].clearValidate();
            this.fundInfo.pay = "";
            if (val === "1") {
                this.bankListsOfR = [];
                this.selectedBankid_card = "";
                if (this.action !== "0") {
                    this.fundInfo.pay = this.bankId;
                    // return;
                }
                this.fundInfo.pay = this.xjbInfo[0] ? this.xjbInfo[0].transactionaccountid : "";
            } else {
                if (val === "2") {
                    if (this.hasBankRroute) {
                        this.bankListsOfR = this.$util.getBankListsOfR(this.bankLists);
                        this.selectedBankid_card = this.bankListsOfR[1]
                            ? this.bankListsOfR[1].bankid_card
                            : "";
                    }
                } else {
                    this.bankListsOfR = [];
                    this.selectedBankid_card = "";
                }
                this.getBank();
            }
        },
        "fundInfo.pay"(val) {
            if (this.fundInfo.way === "1") {
                const _x = this.xjbInfo.filter((item) => {
                    return item.transactionaccountid === val;
                })[0];
                if (_x) {
                    this.xjbSel = _x;
                    const _xjbmin =
                        this.fund.xjbmin != null && this.fund.xjbmin !== ""
                            ? Number(this.fund.xjbmin)
                            : 0;
                    this.$set(
                        this.limit,
                        "min",
                        Number(this.xjbSel.netnominbuy) > _xjbmin
                            ? this.xjbSel.netnominbuy
                            : _xjbmin
                    );
                    let _maxCandidates = [this.xjbSel.xjbasset, this.xjbSel.netnomaxbuy];
                    if (this.fund.xjbmax != null && this.fund.xjbmax !== "") {
                        _maxCandidates.push(this.fund.xjbmax);
                    }
                    let _max = Math.min(..._maxCandidates.map(Number).filter((v) => !isNaN(v)));
                    this.$set(this.limit, "max", _max);
                } else {
                    this.$set(this.limit, "min", "0");
                    this.$set(this.limit, "max", "0");
                }
                this.pla =
                    this.$util.fmtNum(this.limit.min) +
                    "元起，最多可投" +
                    this.$util.fmtNum(this.limit.max) +
                    "元";
                this.queryRate();
            }
        },
        "fundInfo.debitcycle"(val) {
            if (val === "0") {
                let arr = this.$cache.getDict("110207");
                let filterArr = arr.filter(
                    (item, index) =>
                        item.subitem !== "29" && item.subitem !== "30" && item.subitem !== "31"
                );
                this.debitdateArr = filterArr.sort((a, b) => a.itemorder - b.itemorder);
            } else if (val === "1" || val === "2") {
                let arr = this.$cache.getDict("110213");
                this.debitdateArr = arr.sort((a, b) => a.itemorder - b.itemorder);
            }
            let _x = this.debitdateArr.length > 0 ? this.debitdateArr[0].subitem : "";
            if (this.fund.action !== "0" && this.fund.investcycle === val) {
                if (this.$util.isEmpty(this.fund.investcyclevalue)) {
                    // investperiodsvalue
                    this.fund.investcyclevalue = this.fund.investperiodsvalue;
                }
                // _x = this.fund.investcyclevalue;
                if (val === "0") {
                    _x = `0${this.fund.investcyclevalue}`.slice(-2);
                } else {
                    _x = this.fund.investcyclevalue;
                }
            }
            setTimeout(() => {
                this.$set(this.fundInfo, "debitdate", _x);
                if (_x !== "3") {
                    this.queyNextplandate();
                }
            }, 10);
        },
        "fund.tano"(val) {
            if (val) {
                this.$nextTick(() => {
                    this.queyNextplandate();
                });
            }
        },
        "fundInfo.nonexistdayflag"(val) {
            setTimeout(() => {
                this.$set(this.fundInfo, "nonexistdayflag", val);
            }, 10);
        },
        // readFileInfoList: {
        //     handler: function (obj) {
        //         if (
        //             obj.every(function (item) {
        //                 return item.read; // 产品概要强制阅读，其他不用
        //             })
        //         ) {
        //             this.checkbox = true;
        //         }
        //     },
        //     deep: true
        // },
        checkbox(val) {
            if (val) {
                // 如果已经完整阅读过产品概要，则不再弹出强制阅读
                if (this.hasReadProductOverview) {
                    return;
                }

                this.currentFileInfoList = [];
                this.readFileInfoList.forEach((item) => {
                    if (item.filetype == "7") {
                        this.currentFileInfoList.push(item);
                    }
                });
                if (this.currentFileInfoList.length > 0) {
                    this.needTime = true;
                    this.pdfVisible = true;
                }
            }
            if (!val) {
                this.readFileInfoList.forEach((item) => (item.read = false));
            }
        },
        // 监听智慧定投信息变化
        setFund: {
            deep: true,
            handler(val) {
                if (this.wisdom && !this.fund.recommend) {
                    this.fund = Object.assign({}, this.fund, val, {
                        querytype: this.fund.querytype
                    });
                }
            }
        },
        selectedBankid_card(val) {
            //            if(val==="undefined_"){
            //                this.$router.push({ name: 'bank'})
            //                return
            //            }
            if (this.fundInfo.way === "2") {
                this.handleBankRroute();
            }
        },
        // // 动态生成首次扣款日期，暂不使用
        // 'fundInfo.debitdate' (val) {
        //     this.getInvestDate()
        // }
        selectedTargetrate(val) {
            if (val === "") {
                setTimeout(() => {
                    document.getElementById("par3Id").focus();
                }, 500);
            }
        },
        inputTargetrate(val) {
            if (val) {
                this.$refs.fundInfo.clearValidate("selectedTargetrate");
            }
            if (isNaN(val) || val.indexOf(".") > -1 || Number(val) < 0) {
                this.inputTargetrate = this.oldInputTargetrate;
            } else {
                this.oldInputTargetrate = this.inputTargetrate;
            }
        },
        activeName(val) {
            if (val === "first") {
                this.fundInfo.indextype = "a";
            }
        },
        generalFund: {
            immediate: true,
            deep: true,
            handler(val) {
                if (!val) return;

                // 父 → 子回显
                this.fundInfo.indextype = val.indextype || "";
                this.fundInfo.policyvalue = val.policyvalue || "";

                //  如果接口已经回来，直接生成均线
                if (this.indexTypeOptions.length) {
                    this.initAverageTypeOptions(this.fundInfo.indextype);
                    this.fixPolicyValue();
                }
            }
        }
    },
    async mounted() {
        this.commonQuestion = this.$const.commonQuestion.commonQuestion13;
        this.subjectIndex = this.$cache.getDict("110211");
        this.investMove = this.$cache.getDict("110270");
        await this.initPwdCheck();
        this.debitcycleArr = this.$cache.getDict("110009");
        this.info = this.$cache.getUser();
        await this.queryCfgIndexAverageForTerminal();

        // 接口回来后，再根据当前 fundInfo 回显
        if (this.fundInfo.indextype) {
            this.initAverageTypeOptions(this.fundInfo.indextype);
            this.fixPolicyValue();
        }
        this.isagreeeasybuy = this.info.custtag || "0";
        // 查询现金宝信息
        this.xjbFundInfo = JSON.parse(sessionStorage.getItem("xjbFundInfo"));
        // 判断是否为实时TA现金宝（有返回值=实时TA，无返回值=普通现金宝）
        const xjbRes = await fundApi.cfgFundrealtimeQueryAll();
        this.isRealtaXjb = !!(xjbRes.data && xjbRes.data.length > 0);

        this.setFundInfo();
        // this.getFileInfo();
        // 查询现金宝转换关系
        await this.checkXjbConvertRelation();
        // 是否开启智能路由
        this.hasBRroute();
        // 查中港互认基金标识
        fundApi
            .getFundLists({
                keyword: this.fund.fundcode,
                pagesize: 20,
                pagenum: 1
            })
            .then((res) => {
                if (res.data) {
                    const list = res.data.list;
                    this.mrfflag = list.length > 0 && list[0].mrfflag === "1";
                    this.fundData = list.length > 0 && list[0];
                    this.getFileInfo();
                    this.showWarningHtml(warningHtml.warningHtml13);
                }
            });
        this.showWarningHtml(warningHtml.warningHtml13);
        this.$cache.getCompanyInfoParam("10102033") &&
            this.isInTimeRange(
                this.$cache.getCompanyInfoParam("10102033"),
                format(new Date(), "YYYYMMDDhhmmss")
            );
        this.$nextTick(() => {
            this.initTradeSdxAccess();
        });
    },
    methods: {
        formatCurrencyAnnualRate(rate) {
            // 现金宝七日年化按产品口径固定展示3位小数，避免复用通用涨跌幅的2位精度。
            if (this.$util.isEmpty(rate)) {
                return "--";
            }
            return this.$util.fmtNum(rate, 3) + "%";
        },
        goAddBank() {
            if (this.$util.checkAddBankBlocked()) return;
            this.$router.push({ name: "addbank" });
        },
        goAddBankPlan() {
            if (this.$util.checkAddBankBlocked()) return;
            this.$router.push({ name: "addbank", query: { biztype: "plan" } });
        },
        goAddBankOrBank() {
            if (this.fundInfo.way !== "3" && this.$util.checkAddBankBlocked()) return;
            this.$router.push({ name: this.fundInfo.way === "3" ? "bank" : "addbank" });
        },
        // 查询现金宝与当前产品的转换关系
        async checkXjbConvertRelation() {
            // 只有非实时TA现金宝时才需要查询
            if (this.isRealtaXjb) {
                this.hasXjbConvertRelation = true;
                return;
            }

            try {
                // 查询现金宝到当前产品的转换关系
                const res = await fundApi.queryTradeConvertInfo({
                    fundcode: this.xjbFundInfo.fundcode,
                    sharetype: this.xjbFundInfo.sharetype
                });
                if (res.data && res.data.length > 0) {
                    // 检查当前产品是否在可转换列表中
                    const targetFundCodes = res.data.map((item) => item.fundcode);
                    this.hasXjbConvertRelation = targetFundCodes.includes(this.fund.fundcode);
                } else {
                    this.hasXjbConvertRelation = false;
                }
            } catch (error) {
                this.hasXjbConvertRelation = false;
            }
        },
        async initPwdCheck() {
            const pwdBusinessCode =
                this.generalFund.way || (this.action === "0" ? "59" : this.fund.way || "");
            if (!pwdBusinessCode) {
                this.isPwdCheck = false;
                return;
            }
            let validPwdTrdList = [];
            try {
                validPwdTrdList = JSON.parse(sessionStorage.getItem("_validPwdTrdList") || "[]");
            } catch (e) {
                validPwdTrdList = [];
            }
            if (!validPwdTrdList.length) {
                try {
                    await this.$cache.queryValidPwdTrdMethod();
                } catch (e) {
                    this.$log.error("queryValidPwdTrdMethod error:", e);
                }
            }
            this.isPwdCheck = this.$cache.getPwdCheck(pwdBusinessCode);
        },
        // 页面首次进入时尝试消费入口发放的一次性标志；没有标志则立即补前置适当性。
        initTradeSdxAccess() {
            if (!this.$util.isNeedSdxCheck(this.fund)) {
                this.sdxGatePassed = true;
                return;
            }
            this.sdxGatePassed = this.$util.consumeTradeSdxAccess(this.$route.name, this.fund);
            if (!this.sdxGatePassed) {
                this.ensureTradeSdxAccess();
            }
        },
        // 所有继续定投的动作都先经过这里，确保直达页面时也会被适当性阻断。
        ensureTradeSdxAccess(onPassed) {
            if (onPassed) {
                this.pendingSdxAction = onPassed;
            }
            if (!this.$util.isNeedSdxCheck(this.fund)) {
                this.sdxGatePassed = true;
                this.runPendingSdxAction();
                return true;
            }
            if (this.sdxGatePassed) {
                this.runPendingSdxAction();
                return true;
            }
            if (this.sdxDialogVisible) {
                return false;
            }
            this.$util.fundRiskCheck(this, this.fund, (res) => {
                if (res) {
                    this.$util.getSdxProtocol(res, (data) => {
                        if (data) {
                            this.sdxFundInfo = Object.assign({}, data, {
                                way: this.fund.way || this.fundInfo.way || "59"
                            });
                            this.sdxDialogVisible = true;
                        }
                    });
                }
            });
            return false;
        },
        // 适当性通过后恢复当前被阻断的动作，保持用户操作连续性。
        runPendingSdxAction() {
            if (!this.pendingSdxAction) {
                return;
            }
            const pendingAction = this.pendingSdxAction;
            this.pendingSdxAction = null;
            pendingAction();
        },
        // 这里只走原有协议展示链路，前置准入判断交给 ensureTradeSdxAccess。
        proceedSdxProtocol() {
            this.$util.getSdxProtocol(this.fund, (res) => {
                this.fund = res;
                this.protocol = true;
            });
        },
        // 适当性优先级最高；放行后才继续高龄提示、目标盈提示和协议链路。
        continueSubmitInfo() {
            if (!this.selectedTargetrate && Number(this.inputTargetrate) < 4) {
                this.tipVisible = true;
                return;
            }
            // 开了高龄客户管理开关才用
            if (this.$util.buyVerificationOpen() && !this.oldercustRiskWarnPassed) {
                if (this.oldercustRiskChecking || this.buyRiskdialogVisible) {
                    return;
                }
                this.oldercustRiskChecking = true;
                this.$util.checkComplianceService(this.fund.fundcode).then(
                    (checkRes) => {
                        this.oldercustRiskChecking = false;
                        if (this.oldercustRiskWarnPassed) {
                            return;
                        }
                        if (checkRes.dialogType) {
                            this.dialogButtonText = checkRes.dialogButtonText;
                            this.dialogType = checkRes.dialogType;
                            this.dialogContent = checkRes.dialogContent;
                            this.buyRiskdialogVisible = true;
                        } else {
                            this.proceedSdxProtocol();
                        }
                    },
                    () => {
                        this.oldercustRiskChecking = false;
                    }
                );
            } else {
                this.proceedSdxProtocol();
            }
        },
        sdxDialogClose() {
            this.sdxDialogVisible = false;
        },
        // 前置适当性通过后，仅对当前页面放行；刷新后仍需重新具备合法入口或重新校验。
        sdxDialogContinue() {
            this.sdxDialogVisible = false;
            this.sdxGatePassed = true;
            this.fund = Object.assign({}, this.fund, this.sdxFundInfo);
            this.runPendingSdxAction();
        },
        isInTimeRange(timeRange, currentTime) {
            const [start, end] = timeRange.split(",");
            this.tradeRestrictionsShow = currentTime >= start && currentTime <= end;
            return currentTime >= start && currentTime <= end;
        },
        showWarningHtml(warningHtml) {
            let cyclerate = "";
            if (this.fundData.cycleratetype && this.fundData.cycleratevalue) {
                cyclerate = `<p style="color: red">2.买入并确认份额后锁定${
                    this.fundData.cycleratevalue
                }${this.$cache.getDict(
                    "220027",
                    this.fundData.cycleratetype
                )}，期间不可卖出，请做好资金安排</p>`;
            }
            const addWarningHtml = warningHtml + cyclerate;
            this.warningHtml = addWarningHtml;
        },
        clickTab(val) {
            if (
                val === "7" &&
                (this.$util.isEmpty(this.fund.businessflag) ||
                    this.fund.businessflag.indexOf("08") === -1)
            ) {
                this.$message.warning("该基金不支持目标盈定投");
                return;
            }
            if (
                val === "4" &&
                (this.$util.isEmpty(this.fund.businessflag) ||
                    this.fund.businessflag.indexOf("06") === -1)
            ) {
                this.$message.warning("该基金不支持智能定投");
                return;
            }
            this.selectedTab = val;
            if (this.selectedTab === "1") {
                // this.warningHtml = warningHtml.warningHtml13;
                this.showWarningHtml(warningHtml.warningHtml13);
                this.commonQuestion = this.$const.commonQuestion.commonQuestion13;
            }
            if (this.selectedTab === "4") {
                // this.warningHtml = warningHtml.warningHtml16;
                this.showWarningHtml(warningHtml.warningHtml16);
                this.commonQuestion = [];
                // 智能定投切换时，如果现金宝选项被隐藏且当前选中现金宝，强制切回银行卡
                if (!this.showXjbOption && this.fundInfo.way === "1") {
                    this.fundInfo.way = "2";
                }
            }
            if (this.selectedTab === "7") {
                this.fundInfo.way = "2";
                this.warningHtml = "";
                this.commonQuestion = [];
            }
        },
        // 是否开启智能路由
        hasBRroute(val) {
            this.hasBankRroute = sessionStorage.getItem("hasBankRroute", "0") != "0";
        },
        // 获取智能路由
        handleBankRroute() {
            let _this = this;
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(function () {
                let data = {
                    banknameid: _this.selectedBankid_card.split("_")[0], // 银行编号
                    fundtype: _this.fund.fundtype === "2" ? "2" : "1", // 基金类型
                    applicationamount: _this.fundInfo.amount // 申请金额
                };
                _this.$util.request("/acct/bank/route", data).then((res) => {
                    // 获取选择的银行卡下的数据
                    function getData() {
                        let arr = [];
                        _this.bankLists.forEach((item) => {
                            item.options.forEach((item1) => {
                                if (
                                    item1.bankcode === _this.selectedBankid_card.split("_")[0] &&
                                    item1.label.indexOf(_this.selectedBankid_card.split("_")[1]) >
                                        -1
                                ) {
                                    arr[arr.length] = item1;
                                }
                            });
                        });
                        return arr[0] || [];
                    }
                    let recBankInfo = {};
                    _this.hasAccount = false;
                    if (res.data && res.data[0]) {
                        _this.recChannelid = res.data[0].channelid;
                        recBankInfo = _this.getBankInfo(_this.recChannelid);
                        if (recBankInfo.label && !_this.$util.isEmpty(recBankInfo.label)) {
                            // 推荐的渠道网点下有存在的银行卡
                            if (
                                recBankInfo.label.indexOf(_this.selectedBankid_card.split("_")[1]) >
                                -1
                            ) {
                                _this.hasAccount = true;
                                // 推荐的渠道网点下存在的银行卡，正好为当下选择的银行卡
                                _this.bankInfo = recBankInfo;
                                _this.fundInfo.pay = recBankInfo.bankcardid;
                            } else {
                                // 推荐的渠道网点下存在的银行卡，不是当下选择的银行卡
                                _this.bankInfo = getData();
                                _this.fundInfo.pay = _this.bankInfo.bankcardid;
                            }
                        }
                        if (!_this.hasAccount) {
                            // 推荐的渠道网点下无存在的银行卡
                            _this.bankInfo = getData();
                            _this.fundInfo.pay = _this.bankInfo.bankcardid;
                        }
                        // 获取费率
                        _this.queryRate();
                    } else {
                        _this.bankInfo = getData();
                        _this.fundInfo.pay = _this.bankInfo.bankcardid;
                        // 获取费率
                        _this.queryRate();
                    }
                });
            }, 500);
        },
        getBankInfo(channelid) {
            let bankInfo = {};
            for (const group of this.bankLists) {
                if (group.options && group.options.length > 0) {
                    for (const bank of group.options) {
                        if (bank.value === channelid) {
                            bankInfo = bank;
                            break;
                        }
                    }
                }
            }
            return bankInfo;
        },
        // 获取披露文件信息
        getFileInfo() {
            let fundcode = "";
            if (this.$route.query.isCom) {
                this.fund.subfundinfos &&
                    this.fund.subfundinfos.forEach((item, index) => {
                        fundcode +=
                            item.fundcode +
                            (index === this.fund.subfundinfos.length - 1 ? "" : ",");
                    });
            } else {
                fundcode = this.fund.fundcode;
            }
            this.$util.queryReadFileInfo(
                {
                    fundcode: fundcode,
                    filetype: "",
                    scene: sceneEnum.plan,
                    fundshowtype: this.fundData.fundshowtype
                },
                (res) => {
                    res.forEach((item) => {
                        item.read = false;
                        if (item.filetype.trim() === "7") {
                            // 产品概要
                            this.readFileInfoList.unshift(item);
                        } else {
                            this.readFileInfoList.push(item);
                        }
                    });
                    // 此逻辑只针对公募基金
                    if (this.fundData.fundclass == "0") {
                        this.$util.isFundTypeValid(this.fundData).then((flag) => {
                            if (!flag) {
                                // 是否有配置产品概要书
                                let obj = this.readFileInfoList.find(
                                    (item) => item.filetype.trim() === "7"
                                );
                                this.hasProductOverview = !obj;
                                if (this.hasProductOverview) {
                                    this.$message.error(
                                        "协议获取失败，暂时无法交易。如有疑问，请联系客服处理。"
                                    );
                                }
                            } else {
                                this.hasProductOverview = false;
                            }
                        });
                    } else {
                        this.hasProductOverview = false;
                    }
                },
                true
            );
        },
        validateCard(rule, value, callback) {
            if (!this.selectedBankid_card) {
                callback(new Error("请选择支付方式"));
            } else {
                callback();
            }
        },
        checkBuyPlanName(rule, value, callback) {
            // 定投恢复计划名称不校验必填（有的存量数据没有值）
            if (this.action !== "2") {
                if (value.trim() === "") {
                    callback(new Error("请输入计划名称"));
                    return;
                }
                this.$util.validateCCharacter(rule, value, callback);
            } else {
                callback();
            }
        },
        checkDebitdate(rule, value, callback) {
            if (value.trim() === "" && value.trim() !== "5") {
                callback(new Error("请选择扣款日期"));
            } else {
                callback();
            }
        },
        checkDebitcycle(rule, value, callback) {
            if (this.selectedTargetrate !== "") {
                this.inputTargetrate = "";
                callback();
            } else if (this.selectedTargetrate === "" && this.inputTargetrate === "") {
                callback(new Error("请输入自选目标收益"));
            } else {
                callback();
            }
        },
        // 获取链接点击事件
        getClick(index) {
            this.currentFileInfoList = [this.readFileInfoList[index]];
            this.readFileInfoList[index].read = true;
            if (this.currentFileInfoList[0].filetype === "7") {
                this.needTime = true;
            } else {
                this.needTime = false;
            }
            this.pdfVisible = true;
        },
        finishReading() {
            this.pdfVisible = false;
            // 如果阅读的是产品概要（filetype === "7"），标记为已完整阅读
            if (this.currentFileInfoList[0] && this.currentFileInfoList[0].filetype === "7") {
                this.hasReadProductOverview = true;
            }
        },
        cancelReading() {
            this.checkbox = false;
            this.pdfVisible = false;
        },
        // 再次购买重置表单
        reset() {
            // 控制父组件是否显示基金列表
            if (this.wisdom) {
                this.$emit("back-fn", true);
            }
            this.resetOlderCustRiskState();
            this.buySuccess = false;
            this.bankInfo = {};
            this.checkbox = false;
            this.$set(this.fundInfo, "way", "");
            this.$set(this.fundInfo, "amount", "");
            this.$set(this.fundInfo, "buyplanname", "");
            this.$set(this.fundInfo, "pwd", "");
            this.getBuyWay();
        },
        // 高龄风险提示属于单笔交易状态，点击“继续定投”重置表单时需清空，避免复用上一笔确认结果。
        resetOlderCustRiskState() {
            this.oldercustRiskWarnPassed = false;
            this.oldercustRiskChecking = false;
            this.buyRiskdialogVisible = false;
            this.dialogType = "";
            this.dialogContent = "";
            this.dialogButtonText = "";
        },
        validateCCharacter(rule, value, callback) {
            if (value !== "") {
                return this.$util.validateCCharacter(rule, value, callback);
            } else {
                callback();
            }
        },
        // 切换为银行卡支付时数据初始化
        getBank() {
            // 获取银行卡信息
            let _x = this.bankLists[0] ? this.bankLists[0].options[1].bankcardid : "";
            if (this.action !== "0") {
                _x = this.bankId;
            }
            if (_x) {
                this.$set(this.fundInfo, "pay", _x);
                this.bankSel(_x);
            }
        },
        // 处理限额
        amountLimit(rule, value, callback) {
            this.$util.validateAmountLimit(this, rule, value, callback);
        },
        // 处理金额
        isAmount(val) {
            const _val = this.$util.checkAmount(val);
            clearTimeout(this.query);
            this.query = setTimeout(() => {
                this.$set(this.fundInfo, "amount", _val);
                this.queryRate();
            }, 1);
        },
        // 费率入参获取
        queryRate() {
            const _this = this;
            let _d = null;
            if (
                this.fundInfo.amount > 0 &&
                this.fundInfo.sharetype === "0" &&
                ((this.bankInfo.value && this.fundInfo.way !== "1") ||
                    (this.xjbSel.xjbfundcode && this.fundInfo.way === "1")) &&
                this.fund.fundtype !== "2"
            ) {
                _d = {
                    fundcode:
                        this.fundInfo.way === "1" ? this.xjbSel.xjbfundcode : this.fund.fundcode,
                    sharetype: this.fund.sharetype,
                    applicationamount: this.fundInfo.amount,
                    applicationvol: "0",
                    paymode: this.fundInfo.way,
                    businesscode: "59",
                    channelid:
                        this.fundInfo.way === "1" ? this.xjbSel.channelid : this.bankInfo.value
                };
                if (this.fund.comrate) {
                    _d.comratelist = this.fund.comrate;
                }
            }
            this.$util.getFee(_d, (res) => {
                _this.feeGate = res;
            });
        },
        // 对频繁点击按钮做处理
        doAction() {
            const _this = this;
            clearTimeout(this.clickBtn);
            this.clickBtn = setTimeout(() => {
                _this.recAddBank();
            }, 500);
        },
        // 检查是否需要提示新增最优惠渠道卡
        recAddBank() {
            if (this.isOpen) {
                return;
            }
            const _this = this;
            let contentText = "";
            _this.$refs["fundInfo"].validate((valid) => {
                if (valid) {
                    if (_this.fundInfo.way !== "2" || !_this.hasBankRroute) {
                        _this.submitInfo("fundInfo");
                        return;
                    }
                    if (!_this.hasAccount) {
                        _this.$util.getBankInfo({ biztype2: "add-multi" }, (res) => {
                            if (res && res.length > 0 && !_this.$util.isEmpty(_this.recChannelid)) {
                                let canAdd = false; // 是否可以新增推荐渠道下的银行卡
                                for (let i = 0; i < res.length; i++) {
                                    if (_this.recChannelid === res[i].channelid) {
                                        canAdd = true;
                                        _this.recChannelname = _this.$util.getChannelName(res[i], {
                                            channelSubString: true,
                                            bankSubString: false,
                                            subNum: 4
                                        });
                                        contentText =
                                            "使用" +
                                            _this.recChannelname +
                                            "支付更优惠，请添加" +
                                            _this.recChannelname +
                                            "的银行卡";
                                        _this.$util.showMessageBox(
                                            _this,
                                            "温馨提示",
                                            contentText,
                                            "前往增卡",
                                            "继续交易",
                                            function () {
                                                delete res[i].child;
                                                sessionStorage.setItem(
                                                    "recBankInfo",
                                                    JSON.stringify(res[i])
                                                );
                                                _this.goAddBank();
                                            },
                                            function () {
                                                _this.submitInfo("fundInfo");
                                            }
                                        );
                                        return;
                                    }
                                }
                                if (!canAdd) {
                                    _this.submitInfo("fundInfo");
                                }
                            } else {
                                _this.submitInfo("fundInfo");
                            }
                        });
                    } else {
                        _this.submitInfo("fundInfo");
                    }
                } else {
                    this.$errorScroll();
                }
            });
        },
        /* 提交表单数据，校验用户信息 */
        async submitInfo(formName) {
            if (this.readFileInfoList.length !== 0) {
                if (!this.checkbox) {
                    return this.$alert(
                        "根据相关法规要求，请在交易前仔细阅读相关文件，并勾选“我已阅读并同意”选项。",
                        "提示",
                        { confirmButtonText: "确定" }
                    );
                }
            }
            // 获取留痕申请编号
            this.readappno = "";
            await new Promise((resolve) => {
                this.$util.writeFileInfo(
                    {
                        readFileInfoList: this.readFileInfoList,
                        fundcode: this.fund.fundcode,
                        tano: this.fund.tano
                    },
                    (res) => {
                        this.readappno = res;
                        resolve();
                    },
                    this
                );
            });

            const _this = this;
            _this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (_this.action === "1") {
                        let _change = false;
                        try {
                            Object.keys(_this.fundInfo).forEach((key) => {
                                if (_this.fundInfo[key] !== _this.initVal[key] && key !== "pay") {
                                    if (
                                        (key === "amount" &&
                                            Number(_this.fundInfo[key]) !==
                                                Number(_this.initVal[key])) ||
                                        key !== "amount"
                                    ) {
                                        _change = true;
                                        throw new Error("EndIterative");
                                    }
                                }
                            });
                        } catch (e) {
                            if (e.message != "EndIterative") throw e;
                        }
                        if (!_change) {
                            _this
                                .$alert("您未修改任何定投信息，无需提交", "信息未变动提示", "", {
                                    confirmButtonText: "确定",
                                    type: "warning",
                                    callback: (action) => {}
                                })
                                .then(() => {
                                    return false;
                                })
                                .catch(() => {
                                    return false;
                                });
                            return;
                        }
                    }
                    this.ensureTradeSdxAccess(() => {
                        this.continueSubmitInfo();
                    });
                } else {
                    this.$errorScroll();
                }
            });
        },
        // 处理弹窗确认事件（按钮点击）
        handleDialogConfirm() {
            commonApi.commonLeaveTracesLog(this, {
                eventid: this.$const.RECORD.before_purchasing_verification,
                eventname: `高龄客户购买前校验确定按钮`,
                content: JSON.stringify(
                    Object.assign({
                        name: "高龄客户",
                        dialogContent: this.dialogContent,
                        dialogButtonText: this.dialogButtonText
                    })
                )
            });
            // 根据弹窗类型执行不同操作
            if (this.dialogType === "warn") {
                this.oldercustRiskWarnPassed = true;
                this.oldercustRiskChecking = false;
                this.buyRiskdialogVisible = false;
                this.continueSubmitInfo();
            }
        },
        // 获取产品适当性匹配信息
        getSdxProtocol() {
            this.ensureTradeSdxAccess(() => {
                this.proceedSdxProtocol();
            });
        },
        generalBuy(val) {
            this.protocol = false;
            if (!val) return;
            const _this = this;
            if (_this.readFileInfoList.length > 0 && _this.readappno.length === 0) {
                return this.$alert("没有留痕申请编号,操作失败 请联系客服");
            }
            const _x = _this.getInvest();
            // 组合定投
            if (this.$route.query.isCom) {
                this.combInvestPlanManager(_x);
                return;
            }
            let _xjbSel = {};
            // 获取现金宝信息
            if (this.fundInfo.way === "1") {
                _xjbSel = this.xjbInfo.filter((item) => {
                    return item.transactionaccountid === _this.fundInfo.pay;
                })[0];
                // 现金宝不存在，返回
                if (!_xjbSel) {
                    return;
                }
            }
            let data = {
                investcycle: "",
                investcyclevalue: "",
                investperiods: _this.fundInfo.debitcycle,
                investperiodsvalue: _x.investcyclevalue,
                fundmismatchflag: _this.fund.fundmismatchflag,
                bankcode: _this.fundInfo.way === "2" ? _this.bankInfo.bankcode : _xjbSel.bankcode,
                channelid: _this.fundInfo.way === "2" ? _this.bankInfo.value : _xjbSel.channelid,
                paycenterid:
                    _this.fundInfo.way === "2" ? _this.bankInfo.paycenterid : _xjbSel.paycenterid,
                tradepassword: _this.$util.enc(_this.fundInfo.pwd),
                planname: _this.fundInfo.buyplanname,
                continueinvestamount: _this.fundInfo.amount,
                firstsaledate: "",
                firstinvestdate: "",
                contractno: _this.readappno,
                readappno: _this.readappno,
                nonexistdayflag: _this.fundInfo.nonexistdayflag || "",
                transactionaccountid:
                    _this.fundInfo.way === "2"
                        ? _this.bankInfo.transactionaccountid
                        : _xjbSel.transactionaccountid,
                fundcode: _this.fund.fundcode,
                planflag: _this.selectedTab,
                sharetype: _this.fundInfo.sharetype,
                buyflag: _this.fund.riskmismatchflag == "1" ? "1" : "2",
                riskwarnflag: _this.fund.riskwarnflag == "1" ? "1" : "2",
                highriskwarnflag: _this.fund.highriskwarnflag == "1" ? "1" : "2"
            };
            // 现金宝定投（其他基金走新接口 combXjbPlanManage）
            if (_this.fundInfo.way === "1") {
                // 重新启用定投协议处理（现金宝）
                if (_this.action === "2") {
                    const resumeData = {
                        planno: _this.fund.planno,
                        transactionaccountid: _this.fund.transactionaccountid,
                        action: "resume",
                        tradepassword: data.tradepassword
                    };
                    if (_this.oldercustRiskWarnPassed && _this.dialogType === "warn") {
                        resumeData.oldercustriskflag = "1";
                    }
                    _this.planResume(resumeData);
                    return;
                }
                const xjbData = {
                    xjbFundCode: _this.xjbFundInfo.fundcode,
                    fundcode: _this.fund.fundcode,
                    planname: _this.fundInfo.buyplanname,
                    planperiods: _this.fundInfo.debitcycle,
                    planperiodsvalue: _x.investcyclevalue,
                    buyamount: _this.fundInfo.amount,
                    transactionaccountid: _xjbSel.transactionaccountid,
                    tradepassword: _this.$util.enc(_this.fundInfo.pwd),
                    buyflag: _this.fund.riskmismatchflag == "1" ? "1" : "2",
                    riskwarnflag: _this.fund.riskwarnflag == "1" ? "1" : "2",
                    highriskwarnflag: _this.fund.highriskwarnflag == "1" ? "1" : "2",
                    readappno: _this.readappno,
                    paychannel: _xjbSel.paycenterid || ""
                };
                // 修改协议
                if (_this.action === "1") {
                    xjbData.planno = _this.fund.planno;
                }
                // 仅本笔交易已确认高龄风险提示后，才传高龄风险警示标识。
                if (_this.oldercustRiskWarnPassed && _this.dialogType === "warn") {
                    xjbData.oldercustriskflag = "1";
                }
                _this.planOpen(xjbData, true);
                return;
            } else {
                // 银行卡定投
                if (_this.isagreeeasybuy === "1") {
                    if (_this.fundData.internalfundtype != "6") {
                        // 省钱购
                        data.saveplanmode = "3";
                    }
                    data.targetfundcode = _this.xjbFundInfo.fundcode;
                    data.custtag = "1";
                }
                if (
                    _this.fund.fundcode === _this.xjbFundInfo.fundcode &&
                    _this.fundData.internalfundtype != "6" &&
                    _this.isRealtaXjb
                ) {
                    data.saveplanmode = "0";
                }
            }
            // 修改定投协议处理（银行卡）
            if (_this.action === "1") {
                data.planno = _this.fund.planno;
                data.transactionaccountid = _this.fund.transactionaccountid;
            }
            //  重新启用定投协议处理（银行卡）
            if (_this.action === "2") {
                const resumeData = {
                    planno: _this.fund.planno,
                    transactionaccountid: _this.fund.transactionaccountid,
                    action: "resume",
                    tradepassword: data.tradepassword
                };
                if (_this.oldercustRiskWarnPassed && _this.dialogType === "warn") {
                    resumeData.oldercustriskflag = "1";
                }
                _this.planResume(resumeData);
                return;
            }
            // 止盈定投
            if (this.selectedTab === "7") {
                data.policytype = "c";
                data.planflag = "7";
                data.largeredemptionflag = "0";
                if (this.selectedTargetrate) {
                    data.targetrate = this.selectedTargetrate;
                } else {
                    data.targetrate = Number(this.inputTargetrate) / 100 + "";
                }
                data.profitredeemflag = this.profitredeemflag;
                if (this.profitredeemflag === "0") {
                    data.profittobuyfundcode = this.xjbFundInfo.fundcode;
                }
            }
            // 智能定投
            if (this.selectedTab === "4") {
                data.planflag = "4";
                data.policytype = "a";
                data.indextype = _this.fundInfo.indextype;
                data.policyvalue = _this.fundInfo.policyvalue;
                data.investmove = _this.fundInfo.investscale;
                data.formula = "e";
            }
            // 仅本笔交易已确认高龄风险提示后，才传高龄风险警示标识。
            if (this.oldercustRiskWarnPassed && this.dialogType === "warn") {
                data.oldercustriskflag = "1";
            }
            // 下单
            _this.planOpen(data);
        },

        // 组合定投下单（新增，修改，启用）准备
        combInvestPlanManager(_x) {
            let data = {
                custno: this.info.custno,
                transactionaccountid: this.bankInfo.transactionaccountid,
                tradepassword: this.$util.enc(this.fundInfo.pwd),
                status: "0",
                planno: "",
                planperiods: this.fundInfo.debitcycle,
                planperiodsvalue: _x.investcyclevalue,
                portfoliocode: this.fund.portfoliocode,
                buyamount: this.fundInfo.amount,
                paychannel: this.bankInfo.paycenterid,
                saveplanflag: "a",
                riskwarnflag: this.fund.riskwarnflag,
                riskmismatchflag: this.fund.riskmismatchflag,
                highriskwarnflag: this.fund.highriskwarnflag,
                fundmismatchflag: this.fund.fundmismatchflag
            };
            // 仅本笔交易已确认高龄风险提示后，才传高龄风险警示标识。
            if (this.oldercustRiskWarnPassed && this.dialogType === "warn") {
                data.oldercustriskflag = "1";
            }
            // 下单
            this.planOpen(data);
        },

        async planResume(params) {
            const res = await fundApi.planOperation(params);
            // 获取下单时间
            this.cfmdate = res.data ? res.data.nextplandate || "" : "";
            this.resultMes(res);
        },

        async planOpen(params, isXjb = false) {
            this.isOpen = true;
            setTimeout(() => {
                this.isOpen = false;
            }, 3000);
            let apiMethod;
            if (isXjb) {
                apiMethod = "combXjbPlanManage";
            } else if (this.$route.query.isCom) {
                apiMethod = "combInvestPlanManager";
            } else {
                apiMethod = "planOpen";
            }
            const res = await fundApi[apiMethod](params);
            let dateKey = this.$route.query.isCom ? "nextplandate" : "firstinvestdate";
            if (isXjb) {
                dateKey = "firstinvestdate";
            }
            // 获取下单时间
            this.cfmdate = res.data
                ? res.data[dateKey] || (isXjb ? res.data.nextplandate || "" : "")
                : "";
            this.resultMes(res);
            if (params.saveplanmode === "3") {
                this.setCusttag();
            }
        },

        // 初始化扣款周期和扣款日期值
        getInvest() {
            let _x = {
                investperiods: "",
                investperiodsvalue: "",
                investcyclevalue: ""
            };
            const selVal = this.fundInfo.debitdate;
            if (this.fundInfo.debitcycle === "0") {
                _x.investperiods = "0";
                _x.investperiodsvalue = "1";
                _x.investcyclevalue = selVal;
            } else if (this.fundInfo.debitcycle === "1") {
                _x.investperiods = "1";
                _x.investperiodsvalue = "1";
                _x.investcyclevalue = selVal;
            } else if (this.fundInfo.debitcycle === "2") {
                _x.investperiods = "1";
                _x.investperiodsvalue = "2";
                _x.investcyclevalue = selVal;
            } else if (this.fundInfo.debitcycle === "5") {
                _x.investperiods = "2";
                _x.investperiodsvalue = "1";
                _x.investcyclevalue = "1";
            } else {
                _x.investperiods = "";
                _x.investperiodsvalue = "";
                _x.investperiodsvaluedesc = "";
            }
            return _x;
        },
        // 获取第一次扣款日期，暂未使用
        getInvestDate() {
            const _x = this.getInvest();
            const _data = {
                fundcode: this.fund.fundcode,
                tano: this.fund.tano,
                investperiods: _x.investperiods,
                investperiodsvalue: _x.investperiodsvalue,
                investcycle: this.fundInfo.debitcycle,
                investcyclevalue: _x.investcyclevalue
            };
            this.$util.request("trade/plan/firstinvestdate", _data).then((res) => {
                if (res.data) {
                    this.firstinvestdate = res.data[0].firstinvestdate;
                }
            });
        },
        // 获取对应银行卡信息
        bankSel(val) {
            const _this = this;
            for (const group of this.bankLists) {
                if (group.options && group.options.length > 0) {
                    for (const bank of group.options) {
                        if (bank.bankcardid === val) {
                            _this.bankInfo = bank;
                            break;
                        }
                    }
                }
            }
            this.$set(this.limit, "min", this.bankInfo.netnominbuy);
            this.$set(this.limit, "max", this.bankInfo.netnomaxbuy);
            this.pla =
                this.$util.fmtNum(this.bankInfo.netnominbuy) +
                "元起，最多可投" +
                this.$util.fmtNum(this.bankInfo.netnomaxbuy) +
                "元";
            if (this.hasBankRroute && this.fundInfo.way === "2" && this.action === "0") {
                // 获取智能路由
                this.handleBankRroute();
                return;
            }
            this.queryRate();
        },
        // 定投前信息查询
        async getBuyWay() {
            const _this = this;
            // 初始化扣款周期
            let _debit = this.debitcycleArr[0].subitem;
            if (this.$route.query.isCom && _debit === "3") {
                _debit = this.debitcycleArr[1].subitem;
            }
            let _nonexistday = this.nonexistdayArr[0].subitem;
            if (this.action !== "0") {
                if (this.$util.isEmpty(this.fund.investcycle)) {
                    this.fund.investcycle = this.fund.investperiods;
                }
                _debit = this.fund.investcycle;
                _nonexistday = this.fund.nonexistdayflag;
                this.selectedTab = this.fund.planflag;
                if (this.fund.planflag === "7") {
                    if (
                        Number(this.fund.targetrate) == 0.05 ||
                        Number(this.fund.targetrate) == 0.08 ||
                        Number(this.fund.targetrate) == 0.1
                    ) {
                        this.selectedTargetrate = this.fund.targetrate;
                    } else {
                        this.selectedTargetrate = "";
                        this.inputTargetrate = this.fund.targetrate && this.fund.targetrate * 100;
                    }
                    this.profitredeemflag = this.fund.profitredeemflag || "0";
                }
            }
            this.$set(this.fundInfo, "debitcycle", _debit);
            this.$set(this.fundInfo, "nonexistdayflag", _nonexistday);
            let _param = { fundcode: "", portfoliocode: "", sharetype: this.fund.sharetype };
            if (this.$route.query.isCom) {
                _param.portfoliocode = this.fund.portfoliocode;
            } else {
                _param.fundcode = this.fund.fundcode;
            }
            //            _param.fundcode="004040"// 临时代码
            if (this.fund.comrate) {
                _param.combinationflag = this.fund.combinationflag ? this.fund.combinationflag : "";
                _param.combinationrate = this.fund.comrate;
            }
            const res = await fundApi.tradePlan(_param);
            res.data.returnList2 =
                res.data.returnList2 &&
                res.data.returnList2.filter(
                    (item) =>
                        (this.$util.showCounterCard() || item.banktype !== "1") &&
                        item.ischannelstop === "1"
                ); // 临时注释
            res.data.returnList3 =
                res.data.returnList3 &&
                res.data.returnList3.filter(
                    (item) =>
                        (this.$util.showCounterCard() || item.banktype !== "1") &&
                        item.isopenplaninfo === "1" &&
                        item.bankcardsignstatus != "0" &&
                        item.ischannelstop === "1"
                ); // 临时注释
            _this.bankLists =
                res.data.returnList3.length > 0 ? _this.$util.getBankArr(res.data.returnList3) : [];
            if (res.data) {
                this.fund = Object.assign(this.fund, res.data.returnList1, {
                    querytype: this.fund.querytype
                });
                this.xjbInfo = res.data.returnList2 || [];
                // 预处理渠道显示数据
                if (this.xjbInfo && this.xjbInfo.length > 0) {
                    this.xjbInfo = this.xjbInfo.map((item) =>
                        this.$util.preprocessChannelData(item, {
                            channelSubString: false,
                            bankSubString: true,
                            subNum: 6
                        })
                    );
                }
                let _all = 0;
                this.xjbInfo = this.xjbInfo.filter((item) => {
                    return item.xjbasset && Number(item.xjbasset) != 0;
                });
                this.xjbInfo.forEach((item) => {
                    _all += Number(item.xjbasset);
                });
                this.xjbAll = _all;
                // let _way = this.fund.xjbflag == "1" ? "1" : "2";
                let _way = "2";
                if (this.fund.payflag != "1" && this.fund.hkflag == "1") {
                    _way = "3";
                }
                if (_this.action !== "0") {
                    _way = _this.fund.planpaytype == "2" ? "1" : "2";
                    _this.beforePlan(res.data.returnList3);
                }
                if (this.selectedTab === "7") {
                    _this.$set(_this.fund, "way", "2");
                    _this.$set(_this.fundInfo, "way", "2");
                } else {
                    _this.$set(_this.fund, "way", _this.$route.query.isCom === "1" ? "2" : _way);
                    _this.$set(
                        _this.fundInfo,
                        "way",
                        _this.$route.query.isCom === "1" ? "2" : _way
                    );
                }

                // 定投修改时，资金来源需根据定投详情进行赋值
                if (_this.fund.saveplanmode) {
                    _this.$set(this.fundInfo, "way", this.fund.saveplanmode == "2" ? "1" : "2");
                    _this.$set(_this.fund, "way", this.fund.saveplanmode == "2" ? "1" : "2");
                }
                if (["1", "2"].includes(this.action) && this.fund.planflag === "b") {
                    // 修改或恢复时定转资金来源默认选中现金宝
                    this.$set(this.fund, "way", "1");
                    this.$set(this.fundInfo, "way", "1");
                }

                if (_this.fund.sharetype && _this.fund.sharetype != "2") {
                    _this.$set(_this.fundInfo, "sharetype", _this.fund.sharetype);
                }
                // if (_this.fundInfo.sharetype === "0" || _this.fundInfo.sharetype === "1") {
                //     let dict = [{ 0: "A", 1: "B" }];
                //     _this.$set(_this.fundInfo, "sharetype", dict[_this.fundInfo.sharetype]);
                // }
                if (_this.action === "1") {
                    _this.initVal = Object.assign({}, _this.fundInfo, {
                        debitdate: _this.fund.investcyclevalue
                    });
                }
            }
            // });
        },
        // 定投前信息获取
        beforePlan(data) {
            const _this = this;
            if (["1", "2"].includes(this.action) && this.fund.planflag === "b") {
                // 若是现金宝定投，则从现金宝列表中获取数据
                data = this.xjbInfo;
            }
            const _bank = data.filter((item) => {
                return (
                    item.channelid === _this.fund.channelid &&
                    item.paycenterid === _this.fund.paychannel
                );
            })[0];
            if (_bank) {
                this.bankId =
                    this.fund.planpaytype == "2"
                        ? _bank.transid + _bank.xjbfundcode
                        : this.fund.saveplanmode == "2"
                        ? _bank.transactionaccountid
                        : _bank.bankcardid;
            } else {
                _this
                    .$alert(
                        "签署当前定投协议的网点已删除或失效，无法进行下一步操作，点击确认返回首页",
                        "网点信息提示",
                        {
                            confirmButtonText: "确定",
                            type: "warning",
                            callback: (action) => {
                                _this.$router.push("/home");
                            }
                        }
                    )
                    .then(() => {
                        return false;
                    })
                    .catch(() => {
                        return false;
                    });
            }
            // 初始化存在定投协议数据
            this.$set(this.fundInfo, "amount", this.getInvestAmount());
            this.$set(this.fundInfo, "buyplanname", this.fund.buyplanname);
        },
        // 生成确认信息
        resultMes(res) {
            if (res.data) {
                this.result.cla = "register-success";
                this.result.btnMsg =
                    "预计" +
                    (this.action === "1" || this.action === "2" ? "下一" : "首次") +
                    "扣款日期为" +
                    this.$util.fmtDate(this.cfmdate) +
                    "， 如遇节假日则顺延，请耐心等待";
            } else {
                this.result.cla = "register-fail";
                this.result.btnMsg = "原因：" + res.msg;
            }
            if (this.action === "1") {
                this.result.msg =
                    "您的" +
                    (this.fundInfo.way === "1" ? "现金宝" : "") +
                    "定投修改申请已受理" +
                    (this.result.cla === "register-fail" ? "失败" : "成功");
            } else if (this.action === "2") {
                this.result.msg =
                    "您的" +
                    (this.fundInfo.way === "1" ? "现金宝" : "") +
                    "定投启用申请已受理" +
                    (this.result.cla === "register-fail" ? "失败" : "成功");
            } else {
                this.result.msg =
                    "您的" +
                    (this.fundInfo.way === "1" ? "现金宝" : "") +
                    "定投申请已受理" +
                    (this.result.cla === "register-fail" ? "失败" : "成功");
            }

            // 控制父组件是否显示基金列表
            if (this.wisdom) {
                this.$emit("back-fn", false);
            }
            if (this.action !== "0") {
                this.result.btnL = {};
            }
            this.buySuccess = true;
        },
        setFundInfo() {
            this.fund = Object.assign({}, this.generalFund, {
                querytype: this.fund.querytype
            });
            // 定投修改/恢复时，若为定转 (planflag='b'),需要使用目标基金信息
            if (["1", "2"].includes(this.action) && this.fund.planflag === "b") {
                this.fund.fundname = this.getFundName();
                this.fund.fundcode = this.getFundCode();
            }
            this.getBuyWay();
        },
        // 获取基金名称（定转时使用目标基金名称）
        getFundName() {
            return this.generalFund.planflag == "b"
                ? this.generalFund.targetfundname
                : this.generalFund.fundname;
        },
        // 获取基金代码（定转时使用目标基金代码）
        getFundCode() {
            return this.generalFund.planflag == "b"
                ? this.generalFund.targetfundcode
                : this.generalFund.fundcode;
        },
        // 获取定投金额（定转时使用 sellvol）
        getInvestAmount() {
            return this.generalFund.planflag == "b"
                ? this.generalFund.sellvol
                : this.generalFund.firstinvestamount;
        },
        setCusttag() {
            if (
                this.fundInfo.way == "2" &&
                this.isagreeeasybuy == "1" &&
                (this.info.custtag === "0" || this.$util.isEmpty(this.info.custtag))
            ) {
                this.$util.opCustTag("1", this.info);
            }
        },
        formatDate(date) {
            if (date) {
                return format(date, "YYYY-MM-DD");
            }
        },
        async queyNextplandate() {
            const { debitcycle, debitdate } = this.fundInfo;
            if (debitcycle !== "3" && this.fund.tano) {
                const { data } = await userApi.getFirstPlanDay({
                    tano: this.fund.tano,
                    fundcode: this.fund.fundcode,
                    planperiods: debitcycle,
                    planperiodsvalue: debitdate,
                    startdate: format(new Date(), "YYYYMMDD")
                });
                this.nextplandate = data.nextplandate;
            }
        },
        // 查询指数均线
        async queryCfgIndexAverageForTerminal() {
            const res = await fundApi.queryCfgIndexAverageForTerminal({});

            // 接口异常或无数据 → 走老逻辑
            if (!res || !Array.isArray(res.data) || res.data.length === 0) {
                this.useDictFallback();
                this.afterIndexConfigReady();
                return;
            }

            //  正常走新逻辑
            this.cfgIndexAvgList = res.data;

            const map = {};
            res.data.forEach((item) => {
                map[item.indextype] = item.allowaveragetype ? item.allowaveragetype.split(",") : [];
            });
            this.indexAvgMap = map;

            this.initIndexTypeOptions();
            this.applyDefaultPolicy();
        },
        useDictFallback() {
            // 指数类型 = 原字典
            this.indexTypeOptions = this.$cache.getDict("110033") || [];

            // 均线类型 = 原字典
            this.averageTypeOptions = this.$cache.getDict("210312") || [];

            // 清空映射，标识当前是兜底模式
            this.indexAvgMap = {};
        },
        // 指数类型下拉（110033 + 接口过滤）
        initIndexTypeOptions() {
            const dictList = this.$cache.getDict("110033") || [];
            const allowIndexTypes = Object.keys(this.indexAvgMap);

            this.indexTypeOptions = dictList.filter((item) =>
                allowIndexTypes.includes(item.subitem)
            );
        },
        // 指数类型变化时，动态刷新均线
        handleIndexTypeChange(val) {
            this.fundInfo.policyvalue = ""; // 清空已选均线
            this.initAverageTypeOptions(val);
        },
        // 根据 indextype 过滤均线字典（210312）
        initAverageTypeOptions(indextype) {
            //  兜底模式，直接用全量字典
            if (!this.indexAvgMap || !Object.keys(this.indexAvgMap).length) {
                this.averageTypeOptions = this.$cache.getDict("210312") || [];
                return;
            }
            // 正常按接口配置过滤
            const allowAvgTypes = this.indexAvgMap[indextype] || [];
            const avgDict = this.$cache.getDict("210312") || [];

            this.averageTypeOptions = avgDict.filter((item) =>
                allowAvgTypes.includes(item.subitem)
            );
        },
        fixPolicyValue() {
            if (!this.fundInfo.policyvalue) return;

            const exist = this.averageTypeOptions.some(
                (item) => item.subitem === this.fundInfo.policyvalue
            );

            if (!exist) {
                this.fundInfo.policyvalue = "";
            }
        },
        afterIndexConfigReady() {
            // 已有值（编辑态）不覆盖
            if (this.fundInfo.indextype || this.fundInfo.policyvalue) {
                // 但要修一次合法性
                this.initAverageTypeOptions(this.fundInfo.indextype);
                this.fixPolicyValue();
                return;
            }

            this.applyDefaultPolicy();
        },
        applyDefaultPolicy() {
            const { indextype, policyvalue } = {
                indextype: "a",
                policyvalue: "25"
            };

            //  校验指数类型是否可用
            const indexExist = this.indexTypeOptions.some((item) => item.subitem === indextype);
            if (!indexExist) return;

            //  设置指数类型
            this.fundInfo.indextype = indextype;

            //  根据指数类型初始化均线
            this.initAverageTypeOptions(indextype);

            // 校验均线是否可用
            const avgExist = this.averageTypeOptions.some((item) => item.subitem === policyvalue);
            if (avgExist) {
                this.fundInfo.policyvalue = policyvalue;
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.el-select-img {
    width: auto !important;
}
.bank-img-sel {
    width: 400px !important;
    box-sizing: border-box;
}
.long-text-show {
    width: 325px !important;
    text-overflow: clip !important;
}
.comp-plan-buy {
    padding-bottom: 30px;
}
.common-question-contain {
    margin-top: 41px;
    padding: 0 20px;
}
:deep(.el-form-item__label) {
    font-size: 14px !important;
}
:deep(.el-tabs__nav-scroll) {
    padding-left: 13px;
}
.tabForm {
    :deep(.el-form-item__label) {
        width: 160px !important;
        color: var(--color-text-primary) !important;
    }
    :deep(.el-form-item__content) {
        margin-left: 160px !important;
    }
}
:deep(.el-tabs__item) {
    font-size: 16px;
}
.tips-text {
    color: var(--color-text-accent);
    font-size: 14px;
}
.red {
    color: var(--color-primary) !important;
}
.active-tab {
    background-color: var(--color-primary);
    color: #ffffff;
}
.text-primary {
    color: var(--color-primary);
    cursor: pointer;
}
.like-a {
    color: var(--color-primary) !important;
    cursor: pointer;
}
.checked-bg-primary {
    background-color: var(--color-primary);
}

/* 协议勾选框统一样式 */
.protocol-checkbox-group {
    display: flex;
    align-items: flex-start;
    font-size: 14px;

    .protocol-checkbox-label {
        display: flex;
        align-items: center;
        flex-shrink: 0;
        line-height: 40px;

        input[type="checkbox"] {
            width: 18px;
            height: 18px;
            margin: 0;
            cursor: pointer;
        }

        span {
            padding-left: 5px;
            color: red;
        }
    }

    ul {
        margin: 0;
        padding: 0;
        list-style: none;

        li {
            line-height: 40px;

            a {
                color: var(--color-redirect);
                text-decoration: none;
                cursor: pointer;

                &:hover {
                    color: var(--color-primary);
                }
            }
        }
    }
}
</style>
